import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";
import { Menu } from "../entity/SystemEntity";

export class MenuService extends BaseService {
  public loadMenuList(userId: number, success: Success, failure: Failure) {
    super.get("/api/sys/menu/list/user", { userId }).then(
      function(result) {
        const menus: Menu[] = result.data.list as Menu[];
        const parentMenus: Menu[] = [];
        menus.forEach(item => {
          if (item.parentId === 0) {
            item.childMenus = [];
            parentMenus.push(item);
          }
        });
        parentMenus.forEach(parentMenu => {
          const childMenus: Menu[] = [];
          menus.forEach(item => {
            if (item.parentId === parentMenu.id) {
              childMenus.push(item);
            }
          });
          parentMenu.childMenus = childMenus;
        });
        success(parentMenus);
      },
      function(error: Error) {
        failure(error);
      }
    );
  }
}
